export const ZH = {
  preparing_zip: "正在准备压缩包…",
  compressing: "正在压缩…",
  info_icon: "一旦标记为已完成，将无法添加或加入其他成员，所有聊天群组将被停用。请注意，项目及所有聊天群组和数据将在停用状态下保持可访问。",
  mark_is_done: "您确定要将项目标记为已完成吗？一旦标记，将无法添加或加入其他成员，所有聊天群组将被停用。请注意，项目及所有聊天群组和数据将在停用状态下保持可访问。",
  mark_not_done: "您确定要重新开放项目吗？一旦标记为开放，可以添加或加入其他成员，所有聊天群组将被重新激活。",
  mark_as_completed: "将项目标记为已完成",
  room_completed: "项目已完成",
  room_members: "项目成员",
  deactivated_rooms: "已停用的项目",
  deactivated_chats: "已停用的聊天",
  completed_rooms: "已完成的项目",
  request_to_join_a_room: '申请加入项目',
  wants_to_rejoin_room: 'Username想要重新加入项目Roomname。',
  invited_you_to_join_room: 'Username邀请您加入项目Roomname。',
  restart: "重新启动",
  update_text: "有新的更新可用。点击重新启动以安装更新。",
  update_availble: "更新可用",
  Loading: "加载中...",
  logout: "退出登录",
  back: '返回',
  company_list: "公司列表",
  followers: "关注者",
  followings: "正在关注",
  article: "文章",
  companies: "公司",
  one_to_one_chat: " 一对一聊天",
  profile: "个人资料",
  company: "公司",
  company_selection: "公司选择",
  home: "主页",
  contact: "联系人 ",
  add_company: "添加公司 ",
  add_project: "添加项目 ",
  capacities: "服务能力 ",
  work_area: "工作区域",
  company_services: "公司服务",
  website: "网站",
  search_contacts: "搜索联系人",
  add_or_join_a_company: "添加或加入公司",
  follow: "关注",
  following: "正在关注",
  like: "点赞",
  company_contacts: "公司联系人",
  leave_the_company: "离开公司",
  news: "新闻",
  earlier: "更早",
  action: "操作",
  another_action: "其他操作",
  something_else: "其他",
  search: "搜索",
  search_rooms: "搜索项目",
  search_articles: "搜索文章",
  contacts: "联系人",
  suggestions: "建议",
  project_list: "项目列表",
  search_results: "搜索结果",
  add_or_join_project: "添加或加入项目",
  details: "详情",
  your_position_within_company:
    "请选择您在公司中的职位。",
  close_modal: "关闭",
  map: "地图",
  or: "或",
  name: "名称*",
  street: "街道*",
  house_number: "门牌号",
  postal_code: "邮政编码",
  city: "城市*",
  opened_by: "开放者：",
  project_No: "项目编号： ",
  building_type: "建筑类型*",
  building_types: "建筑类型",
  add_join: "添加/加入",
  mandatory_fiels: "*必填字段",
  invalid_fiels: "此字段为必填项",
  add_or_join_company: "添加或加入公司",
  name_of_the_company: "公司名称",
  edit_company_details: "编辑公司详情",
  branch_of_the_building_industry: "建筑行业分支",
  corporate_form: "公司形式",
  position_within_company: "公司内职位",
  request_confirmation: "待处理的项目请求",
  company_e_mail: "公司电子邮件",
  type_of_filter: "输入以过滤...",
  setting: "设置",
  dashboard: "仪表板",
  settings: "设置",
  views: "浏览量",
  times_seen: "次浏览",
  see_more: "...更多",
  see_less: "...更少",
  in_search: "在搜索中",
  reset_password: "重置密码",
  submit: "提交",
  password: "密码",
  email: "电子邮件",
  confirm_password: "确认密码",
  reset_email: "重置电子邮件",
  update: "更新",
  new_email: "新电子邮件",
  kjuup_message: "Kjuup 消息",
  delete_profile: "删除个人资料？",
  my_position: "我的职位：",
  add: "添加",
  owner_company_admin: "公司管理员 ：",
  owner_company_admin_new: "公司管理员",
  mutual_contact: "共同联系人",
  mutual_contacts: "共同联系人",
  co_owner: "共同所有者",
  managing_director: "总经理",
  associate: "合伙人",
  secretary: "秘书",
  employee: "员工",
  project_manage: "项目经理",
  auto_chat_translation: "自动聊天翻译",
  translate_room_group_names: "翻译聊天群组名称",
  translate_room_group_names_info: "启用后，聊天群组名称会自动翻译为界面语言。",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "启用后，打开应用时将默认打开电子邮件选项卡而不是消息。",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "语言",
  english: "英语",
  german: "德语",
  french: "法语",
  italian: "意大利语",
  change_language: "更改语言",
  my_companies: "我的公司",
  employees: "员工",
  invite_with_a: "邀请加入Kjuup",
  add_member: "添加成员",
  add_user: "添加用户",
  send_location: "发送位置",
  assign_admin_rights: "调整管理员权限",
  deactivate_company: "停用公司",
  remove_employees: "移除员工",
  remove_members: "移除成员",
  no_user_found: "未找到用户！",
  approve: "批准！",
  deselect_all: "取消全选",
  select_all: "全选",
  translation_on_building_projects: "项目内翻译",
  reported_capacities: "已报告的服务",
  up_to_50m_exact: "精确到50米",
  company_details_service: "公司服务",
  company_contact: "公司联系人",
  invite_with_link: "邀请加入Kjuup",
  share_link: "分享链接",
  share_company_link: "分享链接",
  qr_code: "二维码",
  copy_link: "复制链接",
  cancel_link: "取消链接",
  who_has_confirmed_services: "谁确认了您的服务？",
  projectss: "项目",
  add_services: "添加服务",
  services: "服务",
  save_text: "保存",
  share_on: "分享到：",
  articlen: "文章",
  invite_user_to_confirm_service:
    "邀请用户确认公司的服务。",
  link_copied: "链接已复制！",
  email_copied: "电子邮件已复制！",
  personal_article: "个人文章",
  company_article: "公司文章",
  characters_remaining: "剩余字符",
  optional_information: "可选信息",
  project: "项目",
  projects: "项目...",
  abort: "放弃",
  preview: "预览",
  post: "发布",
  of: "的",
  remove: "移除",
  free_capacity: "工作门户",
  current_status_overview: "当前状态概览",
  report_capacities: "报告服务",
  report_text: "报告",
  search_capacities: "查找承包商",
  add_project_user: "添加项目用户",
  media: "媒体",
  links: "链接",
  docs: "文档",
  featured_products: "精选产品...",
  title: "标题",
  text: "文本",
  feed_details: "动态详情",
  add_employee: "添加员工",
  latest: "最新",
  my_projects: "我的项目",
  cancel: "取消",
  continue: "继续",
  role_in_the_building_industry: "建筑行业中的角色",
  als: "作为",
  join: "加入",
  find: "查找",
  request_to_join_a_company: "申请加入公司",
  wants_to_join_the_company: "想要加入公司",
  filter_by: "筛选条件",
  ok: "确定",
  close: "关闭",
  weekly_statistics: "每周统计",
  is_following_you: "正在关注您。",
  as: "作为",
  has_joined_the: "已加入公司",
  has_looked_at_your_profile: "查看了您的个人资料。",
  time: "时间",
  in_searches_in_past_week: "在过去一周的搜索中。",
  has_liked_your_article: "喜欢您的文章。",
  has_published_a_new_article: "发布了一篇新文章。",
  you: "您",
  all_views: "所有浏览",
  all_profile_views: "所有个人资料浏览",
  mutual_company: "共同公司",
  artical_text: "撰写文章...",
  you_have_appeared: "您出现了",
  your_request_at_the_company: "您在公司的请求",
  times_you_have_appeared_in_searches: "次您出现在搜索中",
  appear_more_often_in_searches: "在搜索中更频繁地出现",
  you_have_been_found: "您被找到了",
  improve_profile: "改进个人资料",
  choose_existing_contact_for_single_chat:
    "选择现有联系人进行单独聊天：",
  in_order_to_add_new_contacts:
    "要添加新联系人，请在个人资料页面搜索新联系人。",
  times_in_searches_in_the_last_week:
    "次在上周的搜索中。更新您的个人资料并添加更多详细信息，以便更容易被找到。",
  has_been_confirmed: "已被确认。",
  have_joined_the: "已加入  ",
  building_project: " 建筑项目。",
  select_with_which_company_you_want_to_connect_to_the_project:
    "选择您将代表的公司。这将显示给其他参与者。",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "选择您将代表的公司。这将显示给其他参与者。",
  select_internal_section: "请选择内部部门",
  select_profile_image: "选择个人资料图片",
  share_user: "分享用户",
  contact_sender_message:
    "分享此链接以邀请非Kjuup成员加入Kjuup。此链接可供多人注册使用。",
  project_sender_message:
    "分享此链接以邀请非Kjuup成员加入项目“项目名称”。此链接可供多人注册并加入Kjuup中的项目“项目名称”。",
  company_sender_message:
    "分享此链接以邀请非Kjuup成员加入公司公司名称。此链接可供多人注册并加入Kjuup中的公司。",
  contact_receivers_message:
    "邀请链接以加入Kjuup。请点击链接注册kjuup。",
  iphone: "iPhone：",
  iphone_recivers_message:
    "如果您通过Apple App Store安装Kjuup，必须在成功下载后点击此链接才能注册。",
  project_receivers_message:
    "邀请链接以加入Kjuup中的项目“项目名称”。请点击链接注册Kjuup并加入项目“项目名称”。",
  company_receivers_message:
    "邀请链接以加入Kjuup中的公司公司名称。请点击链接注册Kjuup并加入公司公司名称。",
  sign_in: "登录",
  enter_your_email_add: "输入您的电子邮件地址",
  forgot_password: "忘记密码",
  dont_have_account: "没有账户？",
  register: "注册",
  get_app: "获取应用",
  registration: "注册",
  dep_ing: "工程师",
  dr: "博士",
  dr_ing: "工程博士",
  dep_ing_arc: "建筑工程师",
  prof: "教授",
  first_name: "名",
  last_name: "姓",
  have_an_account: "已有账户？",
  when_register_you_agree: "注册时您同意我们的",
  term_of_use: "使用条款",
  to: "。",
  in_our: "在我们的",
  data_policy: "数据政策",
  they_find_out: "中了解，",
  we_provide_store_data: "我们如何收集、处理和存储信息。",
  leaving_company_text:
    "您确定要离开公司吗？离开公司后，您将失去对所有公司聊天和项目的访问权限。",
  delete_profile_text:
    "您确定要删除个人资料吗？删除个人资料后，与公司、项目和聊天的所有连接将被移除。您可以随时创建新的个人资料。",
  confirm: "确认",
  reject: "拒绝",
  requet_to_leave: "离开请求",
  choose: "选择",
  your_add_member: "添加成员",
  if_you: "如果您",
  can_not_find: "在这里找不到您的联系人。",
  please_wait: "请稍候..",
  imprint_gtc: "版权声明/一般条款",
  register_confirm_popup: "请先验证您的 Kjuup 电子邮件，然后再登录。我们已向您的收件箱发送确认链接。如果没有看到，请检查垃圾邮件文件夹。",
  PENDING_GROUP_USER:
    "只有在确认加入项目的邀请后才会收到消息。确认加入项目的邀请后将显示额外的消息。",
  PENDING: "等待确认加入项目的邀请",
  denied_group_chat: " 拒绝了项目邀请并离开了此群组。",
  // joined_group_chat: " 已加入房间和此群组。",
  joined_group_chat: " 加入了此群组",
  you_joined_group_chat: "您加入了此群组。",
  Others: "其他",
  LEFT_GROUP: "已离开此聊天群组。",
  YOU_LEFT_GROUP: "已离开此聊天群组。",
  days: "天",
  day: "天",
  hour: "小时",
  hide_project: "隐藏项目",
  hide_project_popup_text:
    "如果您隐藏项目，则无法在Kjuup中找到它们。只有项目成员可以邀请新用户加入项目。",
  branch: "分支",
  photo_video_media_lib: "照片 - 视频媒体库",
  document: "文档",
  location_meeting: "位置/会议",
  all_member_of_project: "项目的所有成员",
  pending_request: "待处理的项目请求",
  no_pending_request: "未找到待处理的请求！",
  news_feed: "新闻动态",
  user_info: "群组信息",
  leave_project: "离开项目",
  media_link_docs: "文件",
  search_chat: "搜索聊天",
  export_chat_group: "导出上个月的聊天群组数据",
  request_complete_chat_history: "请求完整的聊天历史",
  leave_chat_group: "离开聊天群组",
  add_user_project: "添加用户",
  me: "我",
  max_open_one_to_one:
    "目前最多可以在底部和顶部并行打开2个一对一聊天。总共最多可以打开4个一对一聊天。",
  are_you_sure_you_want_leave_chat:
    "您确定要离开此聊天群组吗？",
  create_group: "创建群组",
  adding_members: "正在添加成员...",
  creating_the_chat: "正在创建聊天...",
  finishing_setup: "正在完成设置...",
  group_name: "群组名称",
  by: "来自：",
  mandetory: "*必填",
  delteed: "已删除其个人资料并离开了群组聊天。",
  deleted_direct: "已删除其个人资料并离开了聊天。",
  unhidden_message:
    "如果您取消隐藏项目，所有Kjuup成员都可以找到它们。",
  account_deleted: "账户已被删除。",
  refuse_company: "您确定要拒绝公司邀请吗？",
  follow_additional: "关注其他用户",
  f_add:
    "关注Kjuup的其他用户，使其可用于直接消息。",
  c_inv: "公司邀请",
  invited_o_Company: "您已被邀请加入公司",
  refuse_companyX: "您确定要拒绝公司请求吗？",
  a_Da: "账户已停用。",
  has_deactivated: "已停用其个人资料。",
  reactive: "已重新激活其个人资料。",
  juup_note: "*仅Kjuup+成员可使用用户名注册",
  username: "用户名*",
  email_username: "电子邮件/用户名*",
  sPinText:
    "请提供6位安全PIN码。如果您忘记密码，将需要此PIN码，并且必须确认您的账户。",
  DeleteKjuupPlusText:
    "您确定要删除个人资料吗？删除个人资料后，与公司、项目和聊天的所有连接将被移除。\n\n账户删除后48小时内，您可以通过使用用户名、密码和PIN码登录来重新激活您的账户。",
  reactive_text:
    "您的账户已被删除。请点击重新激活以重新激活您的账户。",
  rac: "重新激活",
  ac_ss: "账户重新激活成功。",
  not_valid_pin: "PIN码无效",
  only_for_kjuup:
    "*通过用户名和PIN码重置密码仅适用于Kjuup+成员。",
  resetPIN: "重置PIN码",
  enter_current_pin: "请输入您当前的PIN码",
  enter_new: "输入新PIN码",
  pin_to_confirm: "请提供PIN码以确认。",
  change_username: "重置用户名",
  pp_not_match: "密码 - 和确认密码不匹配",
  reactive_itself: "您已重新激活您的个人资料。",
  has_deactivated_itself: "您已停用您的个人资料。",
  more_than_two:
    "目前只能同时与2个用户进行直接消息。",
  Chats: "直接消息",
  only_in_mobileL:
    "目前只能通过移动应用上传和发布原生视频。请使用Youtube和Vimeo的视频链接。",
  register_pin_text:
    "请选择您的个人6位PIN码。此PIN码将用于启用账户重置功能。",
  internal_project: "内部",
  external_projects: "外部",
  in_deacticted: "内部部门已停用。",
  create_article: "创建文章",
  new_article_selection: "为外部新闻动态创建文章",
  new_article_selection_internal: "创建内部文章",
  active_trans_title: "开启自动翻译？",
  active_trans: "开启后，所有收到的聊天消息将翻译为您选择的应用程序语言。",
  disable_trans: "您确定要停用自动翻译吗？",
  allow_access_chat: "显示完整的聊天历史",
  toggle_chat_history_on:
    "您确定要让用户看到完整的聊天历史吗？",
  toggle_chat_history_off:
    "您确定要让用户只看到从加入聊天时开始的聊天历史吗？",
  check_selected_settings:
    "请检查所有选定用户的聊天历史设置！",
  chat_from_start_have:
    "您已加入此群组。聊天历史已共享。",
  chat_from_start_has:
    "已加入此群组。聊天历史已共享。",
  Address: "地址",
  read_by: "已读",
  deliver_to: "已送达",
  remaining: "剩余",
  message_info: "消息信息",
  request_to_join_only: "申请加入",
  unfollow: "取消关注",
  company_username: "用户名",
  month: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],
  remove_my_admin_right: "移除我的管理员权限",
  makeEmp: "您确定要从用户中移除公司管理员权限吗？",
  remove_my_self:
    "您确定要从您的账户中移除公司管理员权限吗？",
  makeAdmin: "您确定要授予用户公司管理员权限吗？",
  remove_member: "移除成员",
  remove_following_confirm: "您确定要从关注列表中移除 {name} 吗？",
  remove_follower_confirm: "您确定要从关注您的人中移除 {name} 吗？如果移除，对方将不会收到通知。",
  do_you_really_want_to_remove:
    "您确定要从公司中移除用户名吗？",
  invite_all: "邀请公司的所有成员",
  invite_all_members: "邀请所有成员",
  mems: "所有其他成员",
  dep_loc: "部门/位置/团队",
  depAdmin: "部门管理员",
  add_remove_admin: "添加/移除公司管理员职位",
  add_remove_dep_admin: "添加/移除部门管理员职位",
  remove_employees_dept: "从中移除员工",
  want_to_join_dep:
    "用户名想要加入公司公司名称的部门/位置/团队部门名称。",
  you_invited:
    "您已被邀请加入公司公司名称的部门/位置/团队部门名称。",
  dep_remove:
    "您确定要从用户中移除部门或位置的管理员权限吗？",
  add_dep:
    "您确定要授予用户部门或位置的管理员权限吗？",
  my_self_dep_remove:
    "您确定要从您的账户中移除部门管理员权限吗？",
  member: "成员",
  admin: "管理员",
  remove_project_admin:
    "您确定要从项目中移除成员吗？",
  remove_my_self_project: "您确定要移除管理员权限吗？",
  remove_member_admin_right:
    "您确定要从用户中移除管理员权限吗？",
  add_member_admin_right: "您确定要向用户添加管理员权限吗？",
  add_remove_Poss: "添加/移除管理员职位",
  forward: "转发",
  edit: "编辑",
  only_kjuup_plus_can: "只有Kjuup+公司可以发布文章。",
  add_images: "添加图片",
  request_confirmation: '待处理的项目邀请',
  Activity: "活动",
  latest_messages: "最新消息",
  hours: "小时",
  minute: "分钟",
  seconds: "秒",
  days: "天",
  yesterday: "昨天",
  last_week: "上周",
  next_week: "下周",
  Last_month: "上个月",
  All: "全部",
  register_plus: "注册Plus",
  select_files: "选择文件",
  monthsFullName: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月",
  ],
  company_deploc_receivers_message:
    "邀请链接以加入Kjuup中公司公司名称的部门。请点击链接注册Kjuup并加入公司公司名称。",
  no_news: "没有新闻",
  reminder: "提醒",
  np_reminder: "没有待办事项",
  move_to_reminder: "移至待办事项",
  remove_reminder: "您确定要从待办事项列表中移除此消息吗？",
  remove_all_reminder: "移除所有待办事项",
  remove_all_confirm: "您确定要从待办事项列表中移除所有消息吗？",
  remove_from_reminder: "从提醒中移除",
  prevent_email: "电子邮件不能用作用户名。",
  allow_noti: "请允许通知。",
  join_cap: "加入",
  pass_minimum:
    "**密码需要12个字符，包括小写字母、大写字母、数字和特殊字符。",
  pass_error: "请检查密码要求",
  people_that_like_article: "喜欢该文章的人。",
  people_who_like_article: "喜欢您文章的人。",
  message_delete: "此消息已被删除。",
  message_edited: "已编辑",
  edit_message: "编辑消息",
  edit_window_expired: "消息仅可在发送后 10 分钟内编辑。",
  message_edit_save: "保存",
  copy: "复制",
  bookmark: "书签",
  add_reaction: "添加回应",
  delete_message: "删除消息",
  more_options: "更多选项",
  info: "信息",
  link_invite: "通过链接邀请",
  ll_nkk: "邀请加入Kjuup",
  selected: "已选择",
  is_active: "活跃",
  inactive: "不活跃",
  last_online: "最后在线 {{when}}",
  remove_user_l: "移除",
  link_expire: "每个生成的链接将在72小时内有效。",
  company_language: "公司语言",
  company_language_info:
    "语言选择将用于所有与公司相关的电子邮件确认。",
  s_image: "图片",
  m_image: "图片",
  removeMsg: "点击移除",
  block: '屏蔽',
  unblock: '取消屏蔽',
  blocks: '您确定要屏蔽此用户吗？',
  unblocks: '您确定要取消屏蔽此用户吗？',
  bolcked_click_un_block:
    '您已屏蔽此联系人。点击此处取消屏蔽。',
  you_have_unblocked: '您已取消屏蔽此联系人。',
  you_have_blocked: '您已屏蔽此联系人。',
  unblock_to_send: '取消屏蔽用户以发送消息。',
  pilot_text: "建筑主题专业AI",
  startup_screen_label: "启动屏幕",
  startup_screen_info: "选择启动 Kjuup 时打开的屏幕。",
  startup_screen_feed: "Home",
  startup_screen_messages: "消息",
  startup_screen_saved: "启动屏幕已更新",
email_on: "聊天电子邮件通知",
  email_on_grp: "电子邮件通知",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "激活或停用此项目的电子邮件通知。此选项仅在通过个人设置启用\"聊天电子邮件通知\"时可用。",
  todo_notification_info: "每当有新的待办事项分配给您时，您都会收到通知。",
  info_val: "如果新的聊天消息在短时间内未被阅读，您将收到一封电子邮件。您可以在相应的项目设置或聊天群组信息中为特定项目或聊天关闭此功能。",
  email_groups: "激活或停用此聊天的电子邮件通知。此选项仅在通过个人设置和项目设置启用\"聊天电子邮件通知\"时可用。",
  add_update_email: "添加/更新电子邮件",
  text_to_verifiy: "只有在您有已验证的电子邮件地址时，才能启用\"聊天电子邮件通知\"选项。",
  stored_email: "已存储的电子邮件： ",
  verify_email: "等待确认！",
  join_call:"加入",
  call_is_started:"通话已开始",
  start_chat:"开始直接聊天？",
  project_rooms:"项目",
  download_selected:"下载",
  add_employee_confirm: '您确定要将此用户添加到公司吗？',
  invalid_deeplink: "无效的深度链接URL。缺少必需的参数。",
  deeplink_error: "无法处理深度链接。请稍后再试。",
  // Reply functionality translations
  reply: "回复",
  reply_enter: "输入回复...",
  reply_sent_successfully: "回复发送成功",
  reply_failed: "发送回复失败",
  reply_failed_generic: "发送回复失败。请重试。",
  replying_to_message: "正在回复消息",
  cancel_reply: "取消回复",
  voice_message: "语音消息",
  send: "发送",
  cancel: "取消",
  type_your_reply: "输入您的回复...",
  
  // Auto-suggestion translations
  suggested_replies: "建议的回复",
  suggestions_error: "加载建议失败",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "请稍候。您的文本正在为您单独准备。",
  loading_chat_message: "加载聊天中...",
  
  // Manual ToDo translations
  extracting_message: "正在提取消息...",
  create_todo: "创建待办事项",
  create_todo_confirmation: "您想从此消息创建待办事项吗？",
  select_project_required: "请选择项目/群组",
  only_assigned_can_change_status: "只有被分配的用户可以更改状态",
  todo_summary: "摘要",
  todo_summary_placeholder: "输入待办事项摘要...",
  todo_date: "日期",
  todo_time: "时间",
  todo_date_hint: "留空以使用原始消息日期/时间",
  todo_created_success: "待办事项创建成功",
  todo_creation_failed: "创建待办事项失败",
  create: "创建",
  
  image: "图片",
  images: "图片",
  remove_all_images: "移除所有图片",
  remove_image: "移除图片",
  remove_document: "移除文档",
  remove_recording: "移除录音",
  play_recording: "播放录音",
  upload_image: "上传图片",
  upload_document: "上传文档",
  record_audio: "录制音频",
  stop_recording: "停止录制",
  stop_recording_text: "停止录制",
  please_remove_current_attachment: "请移除当前附件以",
  please_upload_image_file: "请上传有效的图片文件",
  please_upload_valid_document: "请上传有效的文档文件",
  searching_messages: "搜索消息中...",
  loading_more: "加载更多...",
  loading_more_users: "加载更多用户...",
  load_more_users: "加载更多用户",
  no_more_users_to_load: "没有更多用户可加载",
  no_messages_found: "未找到消息",
  try_different_keyword: "尝试不同的关键词或检查拼写。",
  search_messages: "搜索消息、聊天群组、项目和用户...",
  todo: "待办事项",
  np_todo: "没有待办事项",
  move_to_todo: "保存为待办事项",
  remove_todo: "您确定要移除待办事项吗？",
  remove_all_todo: "移除所有待办事项",
  remove_all_todo_confirm: "您确定要移除所有待办事项吗？",
  add_to_todo: "添加到待办事项",
  remove_from_todo: "从待办事项中移除",
  confirm: "确认",
  ok: "确定",
  read_more: "阅读更多",
  show_less: "显示更少",
  show_more: "显示更多",
  audio: "音频",
  video: "视频",
  // Notification Settings
  notification_schedule: "通知时间表",
  notification_schedule_desc: "您只会在选择的时间内收到推送和电子邮件通知。在这些时间之外，通知将被暂停。",
  learn_more: "了解更多",
  allow_notifications: "允许通知：",
  every_day: "每天",
  weekdays: "工作日（周一至周五）",
  custom: "自定义",
  monday: "周一",
  tuesday: "周二",
  wednesday: "周三",
  thursday: "周四",
  friday: "周五",
  saturday: "周六",
  sunday: "周日",
  to: "至",
  notification_settings: "通知",
  notification_settings_saved: "通知设置保存成功",
  notification_settings_error: "保存通知设置失败",
  unavailability_note: "不在通知",
  unavailability_description: "设置外出通知。启用后，该通知将在您的所有聊天中向他人显示，并且通知将被暂停。",
  unavailability_start_date: "开始日期",
  unavailability_end_date: "结束日期",
  unavailability_message: "消息",
  unavailability_message_hint: "使用 {endDate} 作为您返回日期的占位符。",
  unavailability_replacement: "替代联系人",
  unavailability_replacement_placeholder: "输入紧急请求的用户ID",
  unavailability_replacement_current: "当前替代人",
  unavailability_replacement_hint: "如果设置，您的不在通知中将显示一个链接，用于联系此人处理紧急事务。",
  unavailability_replacement_none: "无替代人（可选）",
  unavailability_contact_urgent: "紧急请求请联系",
  unavailability_default_message: "我目前不在办公室，无法访问Kjuup。我将从{endDate}起重新可用，届时会与您联系。",
  unavailability_save: "保存",
  unavailability_deactivate: "停用",
  unavailability_active_until: "有效期至",
  unavailability_saved: "不在通知已保存",
  unavailability_save_error: "保存不在通知失败",
  unavailability_deactivated: "不在通知已停用",
  unavailability_end_date_required: "结束日期为必填项",
  start_time_before_end_time: "开始时间必须早于结束时间",
  loading: "加载中",
  disabled: "已禁用",
  enable: "启用",
  disable: "禁用",
  forwarded: "已转发",
  message_forwarded: "消息已转发！",
  // Schedule Article
  schedule_article_post: "计划文章发布",
  date: "日期",
  time: "时间",
  scheduled_for_publication: "计划发布",
  article_will_be_published_on: "文章将发布于：",
  reset_selection: "重置选择",
  continue: "继续",
  cancel: "取消",
  // Member Selection
  error_loading_members: "加载成员时出错",
  please_fill_all_fields: "请填写所有字段",
  invalid_email: "无效的电子邮件地址",
  member_added_successfully: "成员添加成功",
  error_onboarding_user: "添加用户时出错",
  error_creating_chat: "创建聊天时出错",
  error_creating_group: "创建群组时出错",
  new_group: "新群组",
  please_select_or_enter_group_name: "请选择群组或输入群组名称",
  please_select_or_enter_room_name: "请选择项目或输入项目名称",
  error_creating_room: "创建项目时出错",
  error_opening_chat: "打开聊天时出错",
  privacy_modal_text: "仅当聊天不包含项目经理的相关专业内容时才选择\"私密\"。",
  not_private: "非私密",
  private: "私密",
  error_loading_groups: "加载群组时出错",
  automatic_chat_export: "自动聊天导出",
  automatic_chat_export_info: "激活后，聊天历史将每月自动发送到指定的电子邮件地址。",
  automatic_chat_export_no_email: "要启用自动聊天导出，您需要先添加电子邮件地址。您可以在个人设置中添加您的电子邮件地址。",
  enter_email: "输入电子邮件",
  update: "更新",
  confirm: "确认",
  export_to_email: "导出到以下电子邮件。",
  start_chat_button:"新消息",
  matching_existing_chats: "匹配的现有聊天",
  subject: "主题",
  add_subject: "添加主题",
  chat_subject: "聊天主题：",
  set_project_room: "设置项目",
  matching_existing_project_rooms: "匹配的现有项目",
  name_project_room: "项目名称",
  professional_or_private: "专业或私密",
  professional: "专业",
  privacy_modal_text_updated: "仅当聊天不包含项目经理的相关专业内容时才选择\"私密\"。私密聊天对项目经理不可见。",
  create_internal_chat: "外部 - 或内部聊天？",
  internal_chat_description: "只有您公司的员工可以添加到内部聊天。",
  yes: "是",
  no: "否",
  chat_is_being_created: "正在创建聊天...",
  // Additional translations for hardcoded text
  discard_article_confirm: "确定要放弃对此文章的更改吗？",
  please_enter_article_title: "请先输入文章标题。",
  please_add_mandatory_fields: "请添加所有必填字段",
  product_label: "产品：",
  no_companies_found: "未找到公司",
  visible_to_all_followers: "对所有Kjuup成员可见",
  only_visible_to_employees: "仅对员工可见",
  something_went_wrong: "出了点问题，请重试",
  please_select_department: "请选择部门/位置",
  schedule: "计划",
  please_select_future_date_time: "请选择未来的日期和时间以计划文章。",
  please_select_different_date_time: "请选择不同的日期或时间以计划文章。",
  please_select_later_time: "请为今天选择晚于当前时间的时间。",
  unpin_article: "取消置顶文章",
  pin_article: "置顶文章",
  and: "和",
  others: "其他",
  at: "在",
  // Chat mute/unmute translations
  mute: "静音",
  unmute: "取消静音",
  chat_muted_successfully: "聊天静音成功",
  chat_unmuted_successfully: "聊天取消静音成功",
  mute_chat_confirm: "您确定要将此聊天静音吗？您将不再收到新消息的通知。",
  unmute_chat_confirm: "您确定要取消此聊天的静音吗？您将再次收到新消息的通知。",
  please_select_group_to_forward: "请选择要转发消息的群组",
  // Company translations
  record_not_found: "未找到记录！",
  please_select_position: "请选择职位",
  delete_article_confirm: "您确定要删除此文章吗？",
  delete_company_service_confirm: "您确定要删除公司服务吗？",
  block_translation_confirm: "您确定要为公司所有成员屏蔽项目中的自动翻译吗",
  unblock_translation_confirm: "您确定要为公司所有成员取消屏蔽项目中的自动翻译吗",
  please_select_file: "请选择要上传的文件",
  role_in_building_industry: "建筑行业中的角色*",
  invalid_email_address: "无效的电子邮件地址",
  please_enter_password: "请输入密码",
  password_change_email_sent: "我们已向您的 Kjuup 邮箱发送了一封邮件。请点击邮件中的确认链接以确认您的新密码。",
  please_enter_username: "请输入用户名",
  username_same_as_before: "用户名不能与之前相同",
  profile_deleted_successfully: "个人资料删除成功",
  hardware_requirements: "硬件要求",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU速度最低2GHz<br/>• Windows 7或更高版本 / 所有macOS版本",
  submitting: "提交中...",
  signing_in: "登录中...",
  please_enter_service_name: "请输入服务名称",
  something_went_wrong_error: "啊！出了点问题...",
  something_went_wrong_try_again: "抱歉，出了点问题。请重试",
  position_label: "职位：",
  loading_room: "加载项目中...",
  navigating_to_room: "正在导航到项目",
  loading_chat: "加载聊天中...",
  translate: "翻译",
  show_original: "显示原文",
  saving: "保存中...",
  language_selection_info: "语言选择用于所有与公司相关的电子邮件确认。",
  // Navigation bar labels
  nav_call: "通话",
  nav_home: "主页",
  nav_messages: "消息",
  nav_todo: "待办事项",
  nav_rooms: "项目",
  nav_all_rooms: "所有项目",
  pinned_rooms_max: "最多可以固定 10 个项目。",
  pinned_room_unpin: "取消固定",
  pinned_rooms_drop: "将项目拖到此处以便快速选择",
  nav_profile: "个人资料",
  nav_company: "公司",
  nav_company_documents: "文档",
  nav_logout: "退出登录",
  // Create message dialog
  add_member_title: "添加成员",
  continue_btn: "继续",
  search_placeholder: "搜索",
  no_members_found: "未找到成员",
  no_groups_found: "未找到群组",
  no_rooms_found: "未找到项目",
  search_users_tab: "用户",
  search_documents_tab: "文档",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "没有文件",
  no_documents_available: "No documents",
  searching_users: "正在搜索用户...",
  no_users_found: "未找到用户",
  search_emails_tab: "邮件",
  searching_emails: "正在搜索邮件...",
  no_emails_found: "未找到邮件",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "未命名群组",
  unnamed_room: "未命名项目",
  all_members: "全部",
  room_label: "项目：",
  subject_label: "主题：",
  no_members: "无成员",
  // Loading states for room creation
  creating_structure: "正在创建您的结构",
  opening_chat: "正在打开聊天",
  please_wait: "请稍候...",
  // ToDo page translations
  loading_todo: "正在加载待办事项...",
  task_updated: "任务已更新",
  error_updating_task: "更新任务时出错",
  task_deleted: "任务已删除",
  error_deleting_task: "删除任务时出错",
  delete_task_confirm: "您确定要删除此任务吗？",
  description_label: "描述",
  description_placeholder: "输入描述...",
  date_time_label: "日期和时间",
  save_hint: "Ctrl+Enter保存，Esc取消",
  edit_label: "编辑",
  delete_label: "删除",
  todo_list_title: "待办事项",
  tasks_count: "任务",
  search_placeholder_todo: "搜索...",
  select_task_to_open_chat: "选择任务以打开聊天",
  today: "今天",
  yesterday: "昨天",
  time_suffix: "", // 中文24小时制不需要后缀
  from_chat: "来源待办事项",
  assigned_to: "分配给",
  assign_users: "分配用户",
  no_users_assigned: "未分配用户",
  assign: "分配",
  assign_to: "分配给...",
  navigate_to_chat: "转到聊天",
  navigate_to_email: "转到邮件",
  show_original_message: "显示来源",
  hide_original_message: "隐藏来源",
  status_pending: "待处理",
  status_in_progress: "进行中",
  status_completed: "已完成",
  show: "显示",
  close: "关闭",
  // Log translations
  status_confirmed: "[已确认]",
  log_todo_created: "待办事项 [已创建]",
  log_todo_confirmed: "待办事项 [已确认]",
  log_todo_deleted: "待办事项 [已删除]",
  log_todo_updated: "待办事项 [已更新]",
  log_description_updated: "[描述已更新]",
  log_deadline_updated: "[截止日期已更新]",
  log_assigned_to: "[已分配给] {name}",
  log_unassigned_from: "[已取消分配] {name}",
  log_assignment_added: "[已添加分配]: {name}",
  log_assignment_removed: "[已移除分配]: {name}",
  log_status_updated: "[状态已从] {from} [更改为] {to}",
  log_status_changed: "[状态已更改]",
  log_status_changed_to: "[状态已更改为] {status}",
  log_changed_status_to: "[已将状态更改为]:",
  log_for_user: "[用户]:",
  log_user_updated_status: "[用户已更新其待办事项状态]",
  log_changed_date_to: "[已将日期更改为]:",
  log_changed_description_to: "[已将描述更改为]:",
  log_moved_to: "[已移动到] {status}",
  todo_status_updated_from: "[从]",
  todo_status_updated_to: "[到]",
  filter_pending: "待处理",
  filter_confirmed: "已确认",
  filter_assigned_to_me: "我的任务",
  filter_assigned_by_me: "已委派",
  todo_project_label: "项目:",
  assigned_users: "已分配用户:",
  todo_chat_label: "聊天:",
  history: "历史记录",
  todo_assigned_by: "分配者:",
  todo_assigned_push: "已分配 ToDo:",
  todo_assigned_push_empty: "您被分配了一个新的 ToDo。",
  search_groups: "群组",
  search_chat_groups: "聊天群组",
  search_project_room: "项目",
  search_messages_tab: "消息",
  searching_groups: "搜索群组中...",
  searching_rooms: "搜索项目中...",
  no_groups_found: "未找到群组",
  no_rooms_found: "未找到项目",
  create_poll: "投票",
  poll_question_label: "问题",
  poll_question_placeholder: "提出问题",
  poll_options_label: "选项",
  poll_option: "选项",
  poll_add_option: "添加选项",
  poll_allow_multiple: "允许多选",
  poll_multiple_allowed: "选择一个或多个选项",
  poll_select_option: "选择一个选项",
  poll_view_votes: "查看投票",
  poll_vote_singular: "票",
  poll_vote_plural: "票",
  poll_votes: "投票结果",
  poll_no_votes_yet: "暂无投票",
  transcript_step_processing: "转录进行中...",
  ai_transcript_tab: "AI-转录",
  ai_transcript_info: "仅适用于2026年3月9日之后创建的语音消息。",
  transcript_more: "...更多",
  transcript_less: "...收起",
  ki_transcript_voice_message: "KI-语音消息转录",
  ki_image_analysis: "AI图像分析",
  type_message: "输入消息",
  email_tab_messages: "消息",
  email_tab_email: "电子邮件",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "电子邮件账户",
  email_connect_gmail: "连接 Gmail",
  email_connect_outlook: "连接 Outlook",
  email_no_accounts: "未连接电子邮件账户",
  email_no_accounts_hint: "在个人资料设置中连接电子邮件账户",
  email_no_messages: "无邮件",
  email_from: "发件人",
  email_to: "收件人",
  email_subject: "主题",
  email_disconnect: "断开连接",
  email_disconnect_confirm: "您确定要断开此电子邮件帐户吗？所有已同步的电子邮件将被删除。",
  email_account_disconnected: "邮箱账户已成功断开连接",
  email_account_disconnect_failed: "断开账户连接失败",
  email_connecting: "连接中...",
  email_account_connected: "账户连接成功",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "前往设置",
  email_date: "日期",
  email_reply: "回复",
  email_forward: "转发",
  email_copy_text: "复制文本",
  email_text_copied: "已复制！",
  email_text_copy_failed: "无法复制文本。",
  email_delete: "删除",
  email_not_spam: "非垃圾邮件",
  email_not_spam_success: "邮件已移至收件箱。",
  email_not_spam_failed: "移至收件箱失败。",
  email_delete_confirm: "您确定要删除此电子邮件吗？",
  email_delete_from_folder: "您确定要从{folder}中删除吗？",
  email_delete_permanent_from_folder: "您确定要永久从{folder}中删除吗？此操作无法撤销。",
  email_save_draft_confirm: "您要将此邮件保存为草稿吗？",
  email_save_draft: "保存草稿",
  email_discard: "丢弃",
  email_back_to_compose: "返回撰写",
  email_draft_saved: "草稿已保存。",
  email_draft_save_failed: "保存草稿失败。",
  email_loading: "加载邮件中...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "选择",
  email_attachment_singular: "附件",
  email_attachment_plural: "附件",
  email_back: "返回",
  email_download: "下载",
  email_close: "关闭",
  email_preview: "预览",
  email_preview_not_available: "无法预览",
  email_preview_failed: "无法预览",
  select_attachments: "选择附件",
  email_loading_preview: "正在加载预览...",
  email_mark_unread_failed: "封邮件无法标记为未读。",
  email_delete_failed: "封邮件无法删除。",
  filter_all: "全部",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "直接消息",
  my_notes: "My Space",
  filter_internal_groups: "内部群聊",
  filter_external_groups: "外部群聊",
  filter_group_chats: "群聊",
  filter_groups_internal: "内部",
  filter_groups_external: "外部",
  filter_unread_only: "仅未读",
  room_daily_briefing_info: "启用后，系统会每 24 小时按个人设置中指定的时间生成本项目的报告——但仅当该时段内有活动时。",
  email_select_all: "全选",
  email_deselect_all: "取消全选",
  email_reply_all: "回复全部",
  email_reply_placeholder: "输入您的回复...",
  email_forward_placeholder: "添加消息...",
  email_edit_draft: "编辑草稿",
  email_attach: "附件",
  email_attachment_from_original: "来自原始消息",
  email_remove: "移除",
  email_drop_files: "拖放文件以附加",
  email_loading_attachments: "正在加载附件...",
  email_archive: "归档",
  mark_unread: "标记为未读",
  mark_read: "标记为已读",
  email_all_accounts: "所有账户",
  email_error: "错误",
  email_delete_email_failed: "删除邮件失败。",
  enter_url: "输入URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: '立即订阅',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1个月免费试用',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: '今日无需付款。付费订阅开始前不会要求提供信用卡信息。',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: '在 Kjuup 中直接管理所有邮箱账户',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI 撰写回复 – 你只需确认',
  kjuup_io_feature_tasks: '任务与日历始终自动保持最新',
  kjuup_io_choose_plan: '选择套餐',
  kjuup_io_plan_monthly: '月付',
  kjuup_io_plan_yearly: '年付',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: '由 Stripe 保障 · 随时取消',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: '已收到付款。正在激活订阅…',
  kjuup_io_toast_activating_soon: '已收到付款。您的订阅即将激活。',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '剩余 {count} 小时',
  kjuup_io_trial_left_hour: '剩余 1 小时',
  kjuup_io_trial_left_minutes: '剩余 {count} 分钟',
  kjuup_io_trial_left_minute: '剩余 1 分钟',
  kjuup_io_trial_left_seconds: '剩余 {count} 秒',
  kjuup_io_trial_left_second: '剩余 1 秒',
  kjuup_io_trial_ending_now: '试用即将结束…',
  kjuup_io_request_timeout: '连接超时，请重试。',
  kjuup_io_info_days_free: '{days}天完全免费 – 试用结束后才开始订阅。',
  kjuup_io_discount_total: '您的折扣：{percent}%',
  kjuup_io_discount_company: '{company}：{percent}%',
  kjuup_io_discount_personal: '个人：{percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: '关闭',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: '您的免费试用已结束',
  kjuup_io_trial_ended_body: '订阅 Kjuup.io，继续使用电子邮件及其他高级功能。',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: '您的免费试用已开始',
  kjuup_io_toast_trial_fail: '无法开始免费试用',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / 月',
  kjuup_io_save_amount_year: '每年节省 {price}',
  kjuup_io_billed_annually_amount: '按年计费 {price}',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: '你将获得：',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: '无需信用卡 – 无需支付信息即可立即开始。',
  kjuup_io_info_cancel_anytime: '随时取消 – 无约束，无风险。',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: '计费周期',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: '付款方式已保存。试用结束时开始计费。',
  calendar_sync_info: '自动将所有 Kjuup ToDo 与您的日历同步。',
  calendar_no_accounts: '尚未连接日历。',
  article_new_badge: '最新',
  article_new_posts: '{0} 条新动态',
  documents: '文档',
  add_documents: '添加文档',
  no_preview_available: '无法预览',
  no_preview_hint: '此文件类型无法预览，但仍会正常发送。',
  max_documents_reached: '一次最多只能添加 10 个文档。',
  open_file: '打开文件',
  twofa_title: '双重验证',
  twofa_method_totp: '验证器应用',
  twofa_method_sms: '短信',
  twofa_method_email: '电子邮件',
  twofa_enter_app: '请输入验证器应用中的 6 位验证码。',
  twofa_enter_sms: '请输入我们通过短信发送的 6 位验证码。',
  twofa_enter_email: '请输入我们发送到邮箱的 6 位验证码。',
  twofa_resend: '重新发送验证码',
  twofa_try_another: '尝试其他方式',
  twofa_remember_device: '30 天内不再询问此设备',
  twofa_sent: '我们已发送验证码。',
  twofa_invalid_code: '验证码不正确，请重试。',
  twofa_something_wrong: '出了点问题，请重试。',
  twofa_method_unavailable: '该验证方式不可用。',
  twofa_on_desc: '双重验证已开启。每次登录都需要验证码。',
  twofa_off_desc: '在密码之后增加第二步。验证器应用是最安全的选项。',
  twofa_methods: '方式',
  twofa_on: '已开启',
  twofa_add: '添加',
  twofa_default_method: '默认方式',
  twofa_default: '默认',
  twofa_turn_off: '关闭',
  twofa_disable_hint: '输入密码和当前验证码以关闭双重验证。',
  twofa_disable_need: '请输入密码和验证码。',
  twofa_code_placeholder: '6 位验证码或备用码',
  twofa_send_code: '发送验证码',
  twofa_primary_updated: '默认验证方式已更新。',
  twofa_disabled: '双重验证已关闭。',
  twofa_enabled: '双重验证已开启。',
  twofa_totp_help: '使用 Google Authenticator、Authy 或 1Password 扫描此二维码。也可以手动输入密钥。',
  twofa_secret_copied: '密钥已复制',
  twofa_sms_help: '请输入国际格式的手机号。我们将通过短信发送 6 位验证码。',
  twofa_email_help: '我们将向账户邮箱发送 6 位验证码。',
  twofa_backup_title: '备用验证码',
  twofa_backup_help: '请妥善保存这些一次性备用码。丢失手机时每个码只能使用一次。',
  twofa_copy_codes: '复制验证码',
  twofa_codes_copied: '备用验证码已复制',
  twofa_regenerate: '获取新的备用验证码',
  twofa_regenerate_hint: '这将替换未使用的备用验证码。请输入密码和当前验证码。',
  twofa_backup_remaining: '还剩 {n} 个未使用的备用验证码',
  twofa_new_codes: '新的备用验证码',
  twofa_sms_unavailable: '短信验证码尚不可用。',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "分配给你的 Kjuup 任务会复制到你的 Todoist 里名为 Kjuup 的项目中。在 Todoist 里的修改不会同步回来。",
  todoist_connect: "连接 Todoist",
  todoist_connected: "已连接 Todoist",
  todoist_connect_failed: "连接 Todoist 失败",
  todoist_disconnect: "断开连接",
  todoist_disconnected: "已断开 Todoist",
  todoist_disconnect_confirm: "断开 Todoist？已在 Todoist 中的任务会保留。同步将停止。",
  todoist_sync_now: "立即同步",
  todoist_syncing: "正在同步…",
  todoist_sync_done: "同步完成",
  todoist_sync_failed: "同步失败",
  todoist_auth_error: "请重新连接 Todoist 以继续同步。",
  todoist_last_sync: "上次同步",
  todoist_not_connected: "尚未连接 Todoist",
  todoist_auth_url_failed: "无法打开 Todoist 授权页面。",
  recommend_text: "加入 Kjuup，保持联系，让你的沟通井井有条。汇集你的所有渠道，把消息放进正确的项目，每天早上从摘要和你的任务开始——一切都与你已经在用的应用同步。免费开始：",
  pro_auth_signin_title: '欢迎回来',
  pro_auth_signin_sub: '使用您的工作邮箱登录。',
  pro_auth_email_or_username: '邮箱或用户名',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: '忘记密码？',
  pro_auth_create_account: '创建账户',
  pro_auth_show_password: '显示密码',
  pro_auth_hide_password: '隐藏密码',
  pro_auth_register_sub: '我们将向您发送一个链接以确认您的邮箱。',
  pro_auth_register_plus_sub: '选择一个用户名和密码。接下来请设置您的安全 PIN 码。',
  pro_auth_check_credentials: '请检查您的邮箱和密码',
  pro_news_export_pdf: '导出为 PDF',
  pro_news_pdf_failed: '无法创建 PDF。',
  pro_news_pdf_attachments: '附件',
  pro_news_pdf_video: '视频',
  pro_auth_forgot_sub: '输入您的邮箱，我们将向您发送重置密码的链接。',
  pro_auth_send_link: '发送重置链接',
  pro_auth_plus_reset: '使用 PIN 码重置',
  pro_auth_show_pin: '显示 PIN 码',
  pro_auth_hide_pin: '隐藏 PIN 码',
  v2_auth_plus_only: '仅限 Kjuup+',
  room_action_media: "文件",
  room_tab_overview: "概览",
  room_tab_history: "记录",
  chat_info_media: "文件",
  messages: "消息",
  pro_todo_project_required: "请选择一个项目",
  pro_todo_choose_project: "这项任务属于哪个项目？",
  cockpit_report_delete_confirm: "要删除这份每日报告吗？",
  cockpit_report_deleted: "每日报告已删除",
  cockpit_tab_company: "公司",
  cockpit_bookmarked_priorities: "收藏的任务",
  cockpit_load_error: "无法加载驾驶舱。",
  cockpit_retry: "重试",
  cockpit_yesterday: "昨天",
  cockpit_greeting_morning: "早上好",
  cockpit_greeting_day: "下午好",
  cockpit_greeting_evening: "晚上好",
  cockpit_assistant_q_open: "今天有哪些待办？",
  cockpit_assistant_q_summarize: "总结聊天 {{room}}",
  cockpit_assistant_q_overdue: "哪些任务已逾期？",
  cockpit_assistant_new: "{{n}} 条新消息",
  cockpit_assistant_important: "{{n}} 条重要",
  cockpit_assistant_title: "Kjuup 助手",
  cockpit_assistant_hint: "点击并提问",
  room_overview_priority_no_detail: "报告未提供关于此重点事项的更多详情。",
  room_overview_priority_from: "来源：{{name}}",
  room_overview_priority_open_task: "打开任务",
  cockpit_priority_position: "第 {{index}} 项，共 {{total}} 项优先事项",
  room_overview_today_title: "今日要事",
  room_overview_all_tasks: "全部",
  room_overview_tasks_empty: "没有未完成的截止日期或任务",
  room_overview_appointments_empty: "没有即将到来的预约",
  room_overview_no_priorities: "最新报告中没有未完成的重点事项。",
  cockpit_report_top5: "前 5 项重点事项",
  cockpit_report_todo_created: "已创建任务",
  cockpit_report_source_missing: "找不到来源消息。",
  delete_bookmarked_priority_confirm: "确定要删除这个收藏的任务吗？",
  cockpit_report_create_todo: "创建任务",
  cockpit_priorities_deleting: "正在删除 …",
  cockpit_priorities_select: "删除多项",
  cockpit_report_none: "暂无条目。",
  cockpit_priorities_delete_confirm: "确定要删除 {count} 个收藏的任务吗？",
  cockpit_priorities_delete_failed: "{count} 个任务无法删除",
  cockpit_priorities_deleted: "已删除 {count} 个任务",
  cockpit_priorities_selected: "已选择 {count} 项",
  cockpit_channel_connected: "已连接",
  cockpit_channel_not_connected: "未连接",
  cockpit_channel_connect: "连接",
  cockpit_channel_chat: "Kjuup 聊天",
  cockpit_channel_active: "已启用",
  cockpit_channel_hidden: "已隐藏",
  cockpit_channel_enable: "启用",
  cockpit_channel_email: "电子邮件",
  cockpit_channel_check: "检查连接",
  cockpit_channel_fix: "检查",
  cockpit_channel_forward: "转发地址",
  cockpit_channel_not_set_up: "未设置",
  cockpit_channel_set_up: "设置",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "连接已断开",
  cockpit_channel_importing: "正在导入",
  cockpit_channel_removing: "正在断开连接",
  cockpit_channel_reconnect: "重新连接",
  cockpit_channels_title: "渠道",
  cockpit_company_role_super_admin: "公司管理员",
  cockpit_company_role_dept_admin: "部门管理员",
  cockpit_company_role_member: "员工",
  cockpit_company_none: "未找到 Kjuup+ 公司",
  cockpit_company_eyebrow: "公司",
  cockpit_company_inactive: "未激活",
  cockpit_company_settings: "公司设置",
  cockpit_company_employees: "员工",
  cockpit_company_internal_rooms: "内部项目",
  cockpit_report_all_projects: "所有项目",
  cockpit_report_progress_emails: "正在分析电子邮件",
  cockpit_report_progress_chats: "正在分析聊天消息",
  cockpit_report_progress_documents: "正在分析附件和文档",
  cockpit_report_progress_tasks: "正在分析任务",
  cockpit_report_progress_summarizing: "正在分析内容",
  cockpit_report_progress_reading: "正在复用已分析的内容",
  cockpit_report_progress_collecting: "正在收集您项目中的电子邮件、聊天和任务",
  cockpit_report_progress_priorities: "正在整理重点事项、截止日期和决策",
  cockpit_report_progress_queued: "正在准备报告",
  cockpit_report_creating_title: "正在准备您的每日报告",
  cockpit_report_progress_count_one: "已分析 1 项",
  cockpit_report_progress_count_many: "已分析 {{count}} 项",
  cockpit_report_progress_hint: "通常需要一到两分钟，在此期间您可以继续使用驾驶舱。",
  cockpit_report_time_hint: "每日报告会在每天 {{hour}}:00 为最活跃的五个项目生成。",
  room_overview_priorities_title: "当前状态与重点事项",
  room_overview_as_of: "截至 {{time}}",
  cockpit_report_delete: "删除每日报告",
  email_tag_daily_briefing: "每日报告",
  cockpit_report_unread: "新",
  cockpit_report_clear_project: "显示所有项目",
  cockpit_filter_project: "项目",
  cockpit_filter_all_projects: "所有项目",
  cockpit_report_recreate: "重新生成每日报告",
  cockpit_report_hide_previous: "隐藏之前的每日报告",
  cockpit_report_show_previous: "显示之前的每日报告",
  cockpit_report_room_empty: "此项目暂无每日报告",
  cockpit_report_empty: "暂无每日报告",
  cockpit_report_room_empty_hint: "仅为此项目创建每日报告。",
  cockpit_report_needs_mailbox: "请连接电子邮件账户，以便 Kjuup 创建包含自动任务的每日报告。",
  cockpit_report_create: "创建每日报告",
  cockpit_email_connect: "连接电子邮件",
  cockpit_email_none_title: "尚未连接电子邮件账户",
  cockpit_email_none_reports: "连接您的邮箱，让 Kjuup 将收到的邮件分配到您的项目，并创建包含任务的每日报告。",
  cockpit_email_none_client: "连接 Gmail、Outlook 或 IMAP，直接在 Kjuup.io 中阅读、分配和回复邮件。",
  cockpit_email_reports_title: "当前的电子邮件客户端",
  cockpit_email_reports_text: "Kjuup.io 中无收件箱 · {{rooms}} 个项目在 {{hour}}:00 生成每日报告 · 收到的邮件会分配到您的项目。",
  cockpit_email_reports_rooms: "管理项目",
  cockpit_email_settings: "电子邮件设置",
  cockpit_email_error_title: "检查连接",
  cockpit_email_client_title: "收件箱已连接",
  cockpit_email_accounts_n: "已连接 {{n}} 个账户",
  cockpit_email_last_sync: "上次同步 {{when}}",
  cockpit_email_report_at: "每日报告 {{hour}}:00",
  cockpit_email_open_inbox: "打开收件箱",
  cockpit_email_eyebrow: "Kjuup 电子邮件",
  cockpit_email_accounts_label: "已连接的电子邮件地址",
  email_folder_sent: "已发送邮件",
  email_no_subject: "（无主题）",
  cockpit_email_detail_loading: "正在加载邮件 …",
  cockpit_email_detail_failed: "无法加载该邮件。",
  cockpit_email_detail_empty: "这封邮件没有正文。",
  cockpit_personal_settings: "个人设置",
  cockpit_companies: "公司",
  cockpit_title: "驾驶舱",
  cockpit_back: "返回概览",
  cockpit_day_overview: "您的一天概览",
  email_saved_to_project: "邮件已保存到项目",
  email_classify_need_project: "请输入项目名称",
  cockpit_email_deleted: "邮件已删除",
  cockpit_email_sent_empty: "暂无已发送邮件。",
  cockpit_email_incoming_empty: "暂无收到的邮件。",
  cockpit_email_incoming_title: "邮件",
  cockpit_email_incoming_sub: "将收到和已发送的邮件分配到您的项目。您可以在此调整分配。",
  cockpit_email_incoming_unassigned_n: "{{n}} 封未分配",
  cockpit_email_folder_inbox: "收件箱",
  cockpit_email_folder_sent: "已发送",
  cockpit_email_open: "打开邮件",
  cockpit_email_incoming_suggested: "建议：{{room}}",
  cockpit_email_incoming_apply: "应用",
  cockpit_email_incoming_adjust: "调整分配",
  cockpit_email_incoming_saving: "正在保存 …",
  cockpit_email_incoming_unassigned: "未分配",
  cockpit_email_incoming_show_less: "收起",
  cockpit_email_incoming_show_all: "显示全部 {{n}} 项",
  cockpit_io_settings: "Kjuup.io 设置",
  cockpit_io_settings_sub: "套餐与席位、员工分配、账单和发票。",
  products_coming_soon: "即将推出",
  cockpit_upsell_io_title: "为您着想的办公室",
  cockpit_upsell_io_text: "将您的电子邮件账户与 Kjuup 连接。邮件、附件和消息会自动保存到相应的项目中，也可选择存储在您的服务器上。您每天都会收到所有项目的摘要，包含所有内容的要点，您的任务还可与日历或待办应用同步。",
  cockpit_upsell_io_soon_title: "尚不可订购",
  cockpit_upsell_io_soon_text: "Kjuup.io 即将上线。立即申请了解详情——可订购时我们会通知您。",
  cockpit_upsell_io_planned_price: "计划价格",
  cockpit_upsell_io_cta_request: "申请了解详情",
  kjuup_plus_abo_per_year: "/ 年",
  kjuup_plus_abo_per_month: "/ 月",
  kjuup_plus_abo_status_active: "有效",
  kjuup_plus_abo_status_requested: "已申请取消",
  kjuup_plus_abo_status_past_due: "待付款",
  kjuup_plus_abo_eyebrow: "Kjuup+ · 订阅",
  kjuup_plus_abo_title: "Kjuup+ 套餐",
  kjuup_plus_abo_seats_free_one: "剩余 1 个席位",
  kjuup_plus_abo_billing: "计费",
  kjuup_plus_abo_yearly: "按年",
  kjuup_plus_abo_monthly: "按月",
  kjuup_plus_abo_amount: "金额",
  kjuup_plus_abo_ends: "结束于",
  kjuup_plus_abo_renews: "下次续订",
  kjuup_plus_abo_next_invoice: "下一张发票",
  kjuup_plus_abo_intro: "入门价",
  kjuup_plus_abo_pending_tier: "自下次续订起",
  kjuup_plus_abo_manual: "您公司的 Kjuup+ 已按个别协议激活。",
  kjuup_plus_abo_invoices: "发票",
  kjuup_plus_abo_invoice_paid: "已支付",
  kjuup_plus_abo_invoice_view: "查看",
  kjuup_plus_abo_invoices_less: "收起",
  kjuup_plus_abo_member_hint: "计费和取消由您公司的管理员管理。",
  kjuup_plus_abo_withdraw: "撤回申请",
  kjuup_plus_abo_cancel_note: "原因（可选）",
  kjuup_plus_abo_cancel_send: "申请取消",
  kjuup_plus_abo_cancel: "取消订阅",
  cockpit_upsell_plus_f1: "管理所有员工的沟通活动",
  cockpit_upsell_plus_f2: "向公司内的特定用户组发送通知",
  cockpit_upsell_plus_f3: "保存内部群聊",
  cockpit_upsell_plus_when_yearly: "按年付费时",
  cockpit_upsell_plus_size_small: "1–50 名员工",
  cockpit_upsell_plus_size_large: "51–200 名员工",
  cockpit_upsell_plus_title: "面向企业的 Kjuup+",
  cockpit_upsell_plus_text: "在一处管理员工、写入权限和公司沟通。内部渠道仅限团队使用，外部渠道将您与项目合作伙伴连接，您还可以直接联系特定群组。除 Kjuup+ 外，您还可以为员工组订购 Kjuup.io 访问权限。Kjuup+ 和 Kjuup.io 可以组合使用。",
  cockpit_upsell_plus_size: "公司规模",
  cockpit_upsell_plus_billing: "计费",
  cockpit_upsell_plus_per_company: "/ 公司 · 月，不含增值税",
  cockpit_upsell_plus_onboarding: "入门/培训费用取决于公司规模",
  cockpit_upsell_plus_larger: "更大规模公司的价格请咨询",
  cockpit_upsell_plus_cta: "无约束咨询",
  cockpit_kpi_deadlines_tasks: "截止日期和任务",
  cockpit_kpi_appointments: "日程",
  cockpit_room_admin: "项目与聊天管理",
  cockpit_room_admin_sub: "所有公司项目，含成员、媒体和聊天。",
  pro_todo_not_found: "此任务已不可用。",
  cockpit_chip_overdue: "已逾期",
  cockpit_chip_today: "今天",
  cockpit_calendar_week: "第{{week}}周",
  cockpit_prev_week: "上一周",
  cockpit_next_week: "下一周",
  cockpit_chip_requested: "已请求",
  cockpit_todo_due: "截止 {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "来自 {{name}}",
  cockpit_todo_since: "自 {{when}} 起",
  cockpit_todo_no_date: "无日期",
  cockpit_todo_mark_done: "标记为完成",
  cockpit_my_tasks_title: "我的任务",
  cockpit_today_tasks_group: "今日任务",
  cockpit_assign_none: "无人被分配",
  no_project_found: "未找到项目",
  cockpit_row_more_actions: "更多操作",
  needs_date: "分配日期",
  cockpit_assign_proposal: "已识别 {{name}}，是否分配？",
  cockpit_assign_proposal_confirm: "分配",
  cockpit_assign_proposal_dismiss: "忽略",
  cockpit_priority_date: "日期",
  todo_calendar_add: "添加到日历",
  todo_calendar_remove: "从日历中移除",
  cockpit_todo_change_project: "更改项目",
  cockpit_todo_set_date: "设置日期",
  pro_todo_done_confirm: "确定要将此任务标记为完成吗？",
  cockpit_task_delete_failed: "无法删除该任务。",
  cockpit_setup_title: "完成设置",
  cockpit_setup_text: "请决定是否使用聊天，以及 Kjuup.io 作为电子邮件客户端使用，还是仅用于项目和每日报告。",
  cockpit_setup_cta: "立即设置",
  cockpit_group_tasks: "截止日期和任务",
  cockpit_group_appointments: "日程",
  cockpit_report_no_activity: "此项目在过去 24 小时内没有新消息或邮件。",
  cockpit_report_room_unavailable: "此项目不可用。",
  cockpit_report_create_failed: "无法创建每日报告。",
  cockpit_report_created: "每日报告已创建",
  addon_enable_confirm: "启用附加组件？",
  addon_enable: "启用",
  addon_enabled: "附加组件已启用",
  nav_email: "电子邮件",
  nav_my_cockpit: "我的驾驶舱",
  nav_news: "新闻",
  nav_recommend: "推荐",
  pro_todo_status_done: "已完成",
  pro_todo_status_open: "未完成",
  v2_todo_remove: "移除",
  pro_todo_search_people: "搜索人员",
  pro_todo_clear: "清除",
  pro_todo_assigned: "（已分配）",
  pro_todo_no_people: "未找到人员",
  pro_todo_search_rooms: "搜索项目",
  pro_todo_no_rooms_match: "没有符合“{{q}}”的项目",
  pro_todo_no_rooms: "未找到项目",
  pro_todo_activity: "动态",
  pro_todo_show_less: "收起",
  pro_todo_show_all: "显示全部（{{n}}）",
  pro_todo_due: "截止",
  pro_todo_room: "项目",
  pro_todo_select_room: "选择项目",
  pro_todo_status: "状态",
  pro_todo_more: "更多",
  pro_todo_edit_title: "编辑任务",
  pro_todo_description: "描述",
  pro_todo_created_by: "创建者",
  pro_todo_chat: "聊天",
  navigate_to_source: "前往来源",
  todo_calendar_connect_title: "未连接日历",
  todo_calendar_connect_body_web: "请在日历同步设置中连接日历，以便将待办添加到日历。",
  todo_calendar_connect: "连接",
  todo_calendar_removed: "已从您的日历中移除",
  todo_calendar_added_later: "已添加。无法连接到您的日历，Kjuup 稍后会重试。",
  todo_calendar_added: "已添加到您的日历",
  todo_calendar_no_date: "只有带日期的待办才能添加到日历。",
  todo_calendar_failed: "无法更新您的日历，请重试。",
  todo_calendar_date_title: "尚无日期",
  todo_calendar_date_save: "设置日期并添加",
  todo_calendar_date_body_web: "此收藏的任务尚无日期。设置日期后即可添加到日历。",
  kjuup_io_setup_saved: "设置已保存",
  kjuup_io_setup_step: "步骤",
  kjuup_io_setup_chats_title: "您想使用聊天吗？",
  kjuup_io_setup_email_title: "您想在哪里阅读电子邮件？",
  kjuup_io_setup_chats_sub: "与同事和项目合作伙伴的聊天为可选项。您可以随时在驾驶舱中显示或隐藏它们。",
  kjuup_io_setup_email_sub: "这仅用于选择是在 Kjuup 中使用电子邮件客户端，还是继续使用您当前的邮件程序，例如 Outlook 或其他。您之后可以更改。",
  kjuup_io_setup_chats_yes: "是，显示聊天",
  kjuup_io_setup_chats_yes_text: "“消息”包含聊天和电子邮件。项目为所有参与者提供群聊。",
  kjuup_io_setup_chats_no: "否，不使用聊天",
  kjuup_io_setup_chats_no_text: "聊天将被隐藏。“消息”变为“电子邮件”；项目、任务和每日报告保持不变。",
  kjuup_io_setup_email_client: "Kjuup 中的电子邮件客户端",
  kjuup_io_setup_email_client_text: "直接在 Kjuup 中阅读和回复邮件。",
  kjuup_io_setup_email_reports: "当前的电子邮件客户端",
  kjuup_io_setup_email_reports_text: "继续在您当前的程序中阅读和回复，例如 Outlook 或其他。",
  kjuup_io_setup_skip: "稍后",
  next: "下一步",
  kjuup_io_setup_finish: "完成设置",
  today_label: "今天",
  tomorrow_label: "明天",
  cockpit_todo_overdue: "已逾期",
  cockpit_report_management_fazit: "管理摘要",
  cockpit_todo_appointment: "日程",
  cockpit_todo_deadline: "截止日期",
  cockpit_todo_deadline_define: "设定截止日期",
  pro_todo_status_acknowledged: "已确认",
  pro_todo_responsible: "负责人",
  pro_todo_notice_confirmed: "已在聊天中确认",
  pro_todo_notice_sent_at: "消息已发送",
  pro_todo_notice_again: "再次发送消息",
  pro_todo_notice_send: "通过 Kjuup 消息通知",
  pro_todo_add_assignee: "添加",
  pro_todo_edit: "编辑",
  pro_todo_change_room: "更改项目",
  pro_todo_due_on: "截止于",
  pro_todo_edit_due: "编辑截止日期",
  pro_todo_no_date: "无日期",
  pro_todo_edit_description: "编辑描述",
  pro_todo_no_description: "暂无描述",
  pro_todo_title_label: "标题",
  pro_todo_title_placeholder: "输入标题...",
  pro_todo_task: "任务",
  pro_todo_what: "需要做什么？",
  pro_todo_source_email: "电子邮件",
  pro_todo_sources: "来源",
  previous: "上一个",
  kjuup_plus_abo_tier_large: "Kjuup+ Large（最多 {max} 名员工）",
  kjuup_plus_abo_tier_small: "Kjuup+ Small（最多 {max} 名员工）",
  kjuup_plus_abo_status_ends: "{date} 结束",
  kjuup_plus_abo_seats_over: "超过 {max} 名员工 – Kjuup 将与您联系并提供定制报价。",
  kjuup_plus_abo_seats_next: "如有更多员工加入，套餐将自动切换至 {next}（按比例计费）。",
  kjuup_plus_abo_seats_used: "已使用 {used} / {total} 个席位",
  kjuup_plus_abo_seats_free: "剩余 {count} 个席位",
  kjuup_plus_abo_intro_until: "至 {date}",
  kjuup_plus_abo_invoice_open: "未支付 · {date} 到期",
  kjuup_plus_abo_invoices_all: "显示全部 {count} 张",
  kjuup_plus_abo_requested_hint: "已于 {date} 申请取消。Kjuup 将在期限结束时（{end}）确认。",
  kjuup_plus_abo_cancel_hint: "Kjuup 会审核您的申请，并在期限结束时（{end}）确认取消。在此之前 Kjuup+ 保持有效。",
  kjuup_plus_abo_withdrawn: "已撤回取消申请",
  kjuup_plus_abo_requested: "已申请取消",
  cockpit_upsell_plus_intro_hint: "前 {months} 个月，之后 {price}",
  cockpit_upsell_plus_badge: "{months} 个月推广价",
  calendar_syncing: "正在从日历更新…",
  calendar_sync_up_to_date: "日历已是最新",
  calendar_sync_failed: "同步失败",
  delete_multiple_tasks_confirm: "确定要删除{count}个ToDo吗？",
  todos_deleted_count: "已删除{count}个ToDo",
  todos_deleted_partial: "已删除{ok}个ToDo，{fail}个失败",
  todo_unknown: "未知",
  todo_created_from_message: "已根据此消息创建任务",
  kjuup_io_todo_calendar_trial_ended_note: "日历同步 · 订阅",
  kjuup_io_todo_calendar_nudge: "将此待办事项同步到您的日历？",
  kjuup_io_todo_calendar_nudge_cta: "激活 Kjuup.io",
  todo_confirmed: "待办事项已确认",
  pro_todo_bulk_delete_title: "删除 {{n}} 项任务？",
  pro_todo_previous_none_own: "这些逾期任务是他人分配给您的，只能由他们删除。",
  pro_todo_previous_none: "没有逾期任务",
  pro_todo_previous_title: "删除 {{n}} 项逾期任务？",
  pro_todo_previous_text: "您之前几天所有未完成的任务都将被删除。",
  pro_todo_previous_skipped: "他人分配给您的 {{n}} 项任务将保留。",
  unassign_task_confirm: "您要取消分配此任务吗？",
  unassign_label: "取消分配",
  pro_todo_delete_title: "删除任务",
  pro_todo_today: "今天",
  pro_todo_yesterday: "昨天",
  pro_todo_since_yesterday: "自昨天起",
  pro_todo_mark_open: "标记为未完成",
  verify_completion: "验证",
  new_label: "新",
  bookmarked_no_mylist: "已收藏的任务无法添加到我的列表",
  delete_only_own: "您只能删除自己创建的任务",
  todo_clear_all: "清除全部",
  pro_todo_of_completed: "已完成 {{done}} / {{total}}",
  pro_todo_pick_date: "选择日期",
  pro_todo_show_day: "显示当天",
  todo_adjust_list: "调整列表",
  pro_todo_section_upcoming: "即将到期",
  pro_todo_section_done: "已完成",
  pro_todo_room_empty_today: "此项目今天没有任务",
  pro_todo_room_empty_day: "此项目当天没有任务",
  pro_todo_delete_previous: "全部删除",
  todo_my_list_empty: "您今天还没有安排",
  todo_my_list_empty_hint: "点击“调整列表”以添加任务",
  pro_todo_empty_title: "这里没有内容",
  pro_todo_empty_hint: "没有与此视图匹配的任务。",
  pro_todo_selected: "已选择 {{n}} 项",
  delete_selected_count: "删除 ({count})",
  pro_todo_adjust_done: "完成",
  pro_todo_deleting: "正在删除…",
  pro_todo_reopen: "重新打开任务",
  pro_todo_step_done: "已完成",
  move_back_in_progress: "恢复进行中",
  pro_todo_mark_not_started: "标记为未开始",
  back_into_in_progress: "恢复进行中",
  pro_todo_mark_in_progress: "标记为进行中",
  unassign_todo: "取消分配待办事项",
  pro_todo_open_room: "打开项目",
  pro_todo_new_task: "新任务",
  select_user_back_to_in_progress: "选择要恢复为进行中的用户",
  cockpit_email_accounts_n_many: "已连接 {{n}} 个账户",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup 联系人",
  combined_tab_teams: "Teams 联系人",
  combined_bridge_failed: "无法创建 Teams 副本。",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup 和 Teams 联系人：将创建一个新群组，它也会显示在 Microsoft Teams 中。",
  teams_new_chat_title: "新建 Teams 聊天",
  teams_new_chat_topic: "群组名称（可选）",
  teams_new_chat_start: "开始聊天",
  teams_new_chat_creating: "正在创建聊天…",
  teams_new_chat_forbidden: "Microsoft Teams 不允许此聊天（例如组织外的人员或 IT 部门的策略）。",
  teams_new_chat_too_many: "一个聊天的人数过多。",
  teams_new_chat_type_hint: "输入姓名以在你的组织中搜索。",
  teams_new_chat_directory_forbidden: "你的组织不允许搜索目录。仅显示你的 Teams 聊天中的人员。",
  teams_new_chat_account: "账户",
};
